import { Pipe, PipeTransform } from '@angular/core';

import { environment } from 'src/environments/environment';
import { LocalizationService } from '../../services/localization/localization.service';
import { replaceInPattern } from '../utils/string.utils';

@Pipe({
    name: 'l10n',
    pure: false
})
export class L10nPipe implements PipeTransform {
  noLocalizationKeys: Set<string> = new Set();

  constructor(private readonly localizationService: LocalizationService) {}

  transform(id: string, placeholders: Record<string, unknown> = null, performTextParsing = false): string {
    if (!id) {
      return '-';
    }

    let localizedString = this.localizationService.localization[id];

    if (!localizedString) {
      if (!this.noLocalizationKeys.has(id)) {
        console.warn('No localization found. Please check id: ', id);
        this.noLocalizationKeys.add(id);
      }
      return '-';
    }

    if (placeholders) {
      const transformedPlaceholders = placeholders['noTransform']
        ? placeholders
        : Object.keys(placeholders).reduce((acc, key) => {
            acc[`${environment.localizationPlaceholdersPrefix}${key}`] = placeholders[key];
            return acc;
          }, {});

      localizedString = replaceInPattern(localizedString, transformedPlaceholders, {
        replacePredicate: (match: string) => match.includes('Link')
      });
    }

    return performTextParsing
      ? new DOMParser().parseFromString(localizedString, 'text/html').body.textContent
      : localizedString;
  }
}
